// extracted by mini-css-extract-plugin
export default {"layoutMinWidth":"src-pages-Settings-PlanAndBilling-css-module__layoutMinWidth--y6BjV"};